@import 'styles/mixins';

.doNotDisturbContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 8px 18px 8px;
  gap: 10px;
}

.doNotDisturbText {
  @include md-regular;
  color: var(--neutral-90);
  margin-bottom: 8px;
}
